import { CalendarDaysIcon } from '@heroicons/react/24/outline'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import InnovationHelpersModal from '../../../components/trial/innovation-helpers-modal'
import { trackEvent } from '../../../helpers/analytics'

// Dauerhafter Einstieg in die Demo-Buchung, als Footer im AssistantDrawer.
// Bewusst kein fixed-Element auf der Seite: dort lag es je nach z-index
// entweder über dem Assistant-Backdrop oder hinter Sidebar und Fokus-Layer.
// Im Drawer läuft es im Fluss mit und ist auf jedem Onboarding-Screen da
// (Intro, Discover, Create-Career-Flow) — ohne Trial-Kontext, daher
// trialDays={null} im Modal.
export default function DemoBookingFooter({ source = 'onboarding' }) {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  return (
    <div className='shrink-0 border-t border-slate-200 bg-white px-4 py-3'>
      <button
        type='button'
        onClick={() => {
          // Der Footer-Klick ist die erste sichtbare Absicht im Demo-Pfad und war
          // ungetrackt: gemessen wurde erst demo_booking_widget_shown im Modal.
          // Solange beide gleich oft feuern, ist das redundant — weichen sie ab,
          // öffnet das Modal nicht zuverlässig, und genau das würde man sonst nie
          // sehen. Rock Q3/26.
          trackEvent('demo_booking_cta_clicked', { source })
          setOpen(true)
        }}
        className='inline-flex w-full items-center justify-center gap-2 rounded-md px-3 py-2 text-sm font-medium text-blue-600 hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-blue-500'
      >
        <CalendarDaysIcon className='h-5 w-5 shrink-0' />
        {t('trial.innovation_helpers.modal.calendar_action')}
      </button>

      <InnovationHelpersModal open={open} setOpen={setOpen} source={source} />
    </div>
  )
}

DemoBookingFooter.propTypes = {
  source: PropTypes.string
}

DemoBookingFooter.defaultProps = {
  source: 'onboarding'
}
